var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43.86,28.59,31.42,16.15a2.51,2.51,0,0,0-.31-.26L31,15.83a1.67,1.67,0,0,0-.23-.12l-.16-.05-.21-.07-.29,0h-.19l-.3,0-.2.06a.85.85,0,0,0-.17.06l-.22.11-.13.07a2.51,2.51,0,0,0-.31.26L16.14,28.59A2,2,0,0,0,19,31.41l9-9V42.44a2,2,0,0,0,4,0V22.38l9,9a2,2,0,1,0,2.83-2.82Z","transform":"translate(-15.56 -15.56)"}));
}

ArrowUp.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 28.89 28.89"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
